<template>
  <div class="home">
    <Hero
      title=""
      image="banner-home/banner.jpg"
      :searchBox="true"
    />
    <Brands />
    <Job />
    <MissionValues />
    <!-- <Faq /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/media/Hero.vue";
import Slider from "@/components/media/Slider.vue";
import Gallery from "@/components/media/Gallery.vue";
import Faq from "@/components/Faq.vue";
//Components
import Brands from "@/views/home/components/Brands.vue";
import Job from "@/views/home/components/Job.vue";
import MissionValues from "@/views/home/components/MissionValues.vue";

export default {
  name: "Home",

  data() {
    return {
      slides: [
        {
          img: "banner1.jpg",
        },
        {
          img: "banner2.jpg",
        },
        {
          img: "industria.jpg",
        },
      ],
    };
  },

  head() {
    return this.$head({
      title: "",
    });
  },

  computed: {
    teams() {
      return this.$store.state.teams;
    },

    faqItems() {
      return this.$store.state.faqItems;
    },
  },

  components: {
    Hero,
    Slider,
    Gallery,
    Faq,
    Brands,
    Job,
    MissionValues
  },

  mounted() {
    this.$store.dispatch("opportunities/setOpportunities");
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .hero{
    margin-top: 50px;
    .home-search{
      margin-top: 110px;
    }


  }
</style>